import { DosageForm, ProductSearchResult } from 'types/treatments'
import makeApiCall from '.'
import { fetchItemFromStorage, requestLocation } from 'utils'
import { ADDRESS_KEY } from 'app-constants'
import { ShippingAddress } from 'types/shipping'

const baseURL = import.meta.env.VITE_API_GLOBAL_URL

async function getCoords(): Promise<{ latitude: any; longitude: any } | null> {
  const storeData = fetchItemFromStorage<ShippingAddress>(ADDRESS_KEY, 'localStorage')

  if (storeData) {
    return {
      latitude: storeData.coordinates.lat,
      longitude: storeData.coordinates.lng,
    }
  }
  return new Promise((resolve) => {
    const timeoutId = setTimeout(() => {
      resolve(null) // Resolve with null if timeout occurs
    }, 3000)

    requestLocation((coords) => {
      clearTimeout(timeoutId) // Clear the timeout as we got a response
      if (coords && 'latitude' in coords && 'longitude' in coords) {
        resolve(coords)
      } else {
        resolve(null) // Resolve with null if coords are invalid or not found
      }
    })
  })
}

export async function searchDrug(keyword: string) {
  const data = await getCoords()
  return makeApiCall<ProductSearchResult[]>(`/products/search?name=${encodeURI(keyword)}`, '', '', {
    headers: {
      'x-location-lat': data?.latitude,
      'x-location-lon': data?.longitude,
    },
  })
}
export async function pharmacySearchDrugs(payload: { keyword: string; pharmacy_id: string }) {
  const data = await getCoords()
  return makeApiCall<ProductSearchResult[]>(
    `/products/search?name=${encodeURI(payload.keyword)}`,
    '',
    '',
    {
      params: {
        pharmacy_id: payload.pharmacy_id,
      },
    }
  )
}

export function fetchDosageForms() {
  return makeApiCall<DosageForm[]>(`/config/dosage-forms?nopaginate=true`, 'get', '', {
    baseURL,
  })
}
